// import "./ProjectHelpDescription.css";

export default function ProjectHelpDescription() {
  return (
    <div className="">
       <div className="task-top-pane">
        <i class="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="">

        {/* HEADER */}
        <div className="og-hd p-3">
          <div className="og-logo">
             <img src="/images/icon2.png" alt="OG Logo" />
          </div>
          <div>
            <h1>Project &amp; Task Flow</h1>
            <p>How clients, projects, and tasks connect — setup to completion.</p>
          </div>
        </div>

        <div className="app-container-height px-3">

        {/* VISUAL FLOW */}
        <div className="og-flow">
          <div className="og-node">
            <div className="og-node-icon"><i className="fa-solid fa-building"></i></div>
            <div className="og-node-step">Step 1</div>
            <div className="og-node-title">Client</div>
            <div className="og-node-desc">Created once. Required before any project.</div>
          </div>
          <div className="og-arrow"><i className="fa-solid fa-arrow-right"></i></div>
          <div className="og-node">
            <div className="og-node-icon"><i className="fa-solid fa-folder"></i></div>
            <div className="og-node-step">Step 2</div>
            <div className="og-node-title">Project</div>
            <div className="og-node-desc">Public or Private. Holds modules &amp; segments.</div>
          </div>
          <div className="og-arrow"><i className="fa-solid fa-arrow-right"></i></div>
          <div className="og-node">
            <div className="og-node-icon"><i className="fa-solid fa-list-check"></i></div>
            <div className="og-node-step">Step 3</div>
            <div className="og-node-title">Tasks</div>
            <div className="og-node-desc">Created inside projects. Open to all members.</div>
          </div>
        </div>

        {/* DETAILS */}
        <div className="og-details">

          {/* Client */}
          <div className="og-card">
            <div className="og-card-title"><i className="fa-solid fa-building"></i>Client</div>
            <div className="og-tags">
              <span className="og-tag">Company</span>
              <span className="og-tag">Location</span>
              <span className="og-tag">Contact</span>
            </div>
            <div className="og-perm">
              <i className="fa-solid fa-key"></i><strong>Create / Edit</strong> requires permission.
            </div>
            <div className="og-alert">
              <i className="fa-solid fa-circle-exclamation"></i> No client → no project.
            </div>
          </div>

          {/* Project */}
          <div className="og-card">
            <div className="og-card-title"><i className="fa-solid fa-folder"></i>Project</div>
            <div className="og-tags">
              <span className="og-tag">Name</span>
              <span className="og-tag">Manager</span>
              <span className="og-tag">Dates</span>
              <span className="og-tag">Modules</span>
              <span className="og-tag">Segments</span>
            </div>
            <div className="og-perm">
              <i className="fa-solid fa-key"></i><strong>Create / Edit</strong> requires permission.
            </div>
            <div className="og-branches">
              <div className="og-branch og-branch-pub">
                <b><i className="fa-solid fa-globe" style={{ fontSize: "9px" }}></i> Public</b>
                <span>All org members</span>
              </div>
              <div className="og-branch og-branch-prv">
                <b><i className="fa-solid fa-lock" style={{ fontSize: "9px" }}></i> Private</b>
                <span>Named members only</span>
              </div>
            </div>
          </div>

          {/* Tasks */}
          <div className="og-card">
            <div className="og-card-title"><i className="fa-solid fa-list-check"></i>Tasks</div>
            <div className="og-tags">
              <span className="og-tag">Title</span>
              <span className="og-tag">Module</span>
              <span className="og-tag">Segment</span>
              <span className="og-tag">Priority</span>
              <span className="og-tag">Assignee</span>
              <span className="og-tag">Due</span>
            </div>
            <div className="og-info">
              <i className="fa-solid fa-users"></i> All members can view &amp; edit any task.
            </div>
          </div>
        </div>

        {/* PROJECT STATUS */}
        <div className="og-status">
          <div className="og-status-hd">
            <div className="og-status-title"><i className="fa-solid fa-chart-line"></i>Project status</div>
            <span className="og-status-note">Independent of task statuses</span>
          </div>
          <div className="og-pills">
            <span className="og-pill og-pill-green">Active</span>
            <span className="og-pill og-pill-amber">On hold</span>
            <span className="og-pill og-pill-blue">Completed</span>
            <span className="og-pill og-pill-gray">Archived</span>
          </div>
        </div>

        {/* TASK STATUS FLOW */}
        <div className="og-status">
          <div className="og-status-hd">
            <div className="og-status-title"><i className="fa-solid fa-arrows-spin"></i>Task status flow</div>
            <span className="og-status-note">Any state ⇄ any state · Sub-tasks follow the same rules</span>
          </div>

          <div className="og-svg-flow">
            <svg viewBox="0 0 600 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Any-to-any task status flow with gated Closed state">
              <defs>
                <marker id="arr" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
                  <path d="M0,0 L10,5 L0,10 z" fill="#8492a6" />
                </marker>
                <marker id="arrP" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                  <path d="M0,0 L10,5 L0,10 z" fill="#EC4119" />
                </marker>
              </defs>

              <rect x="8" y="8" width="584" height="128" rx="10" fill="#fafbfd" stroke="#e8edf2" strokeDasharray="5 4" />
              <text x="20" y="28" fontSize="11" fontWeight="700" fill="#8492a6" letterSpacing="0.6" fontFamily="Helvetica Neue,Arial,sans-serif">
                ⇄ FREE TRANSITIONS — ANY STATE TO ANY STATE
              </text>

              <path d="M 90 80 Q 235 44, 380 80" stroke="#a8b3c1" strokeWidth="1" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" strokeDasharray="3 2" />
              <path d="M 235 80 Q 360 48, 490 80" stroke="#a8b3c1" strokeWidth="1" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" strokeDasharray="3 2" />
              <path d="M 90 72 Q 290 30, 490 72" stroke="#a8b3c1" strokeWidth="1" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" strokeDasharray="3 2" />

              <g>
                <rect x="40" y="84" width="100" height="36" rx="18" fill="#f8f9fb" stroke="#cbd5e1" strokeWidth="1.2" />
                <text x="90" y="107" textAnchor="middle" fontSize="13" fontWeight="600" fill="#475569" fontFamily="Helvetica Neue,Arial,sans-serif">Open</text>
              </g>
              <g>
                <rect x="175" y="84" width="120" height="36" rx="18" fill="#eff6ff" stroke="#93c5fd" strokeWidth="1.2" />
                <text x="235" y="107" textAnchor="middle" fontSize="13" fontWeight="600" fill="#1d4ed8" fontFamily="Helvetica Neue,Arial,sans-serif">In progress</text>
              </g>
              <g>
                <rect x="330" y="84" width="100" height="36" rx="18" fill="#faf5ff" stroke="#c4b5fd" strokeWidth="1.2" />
                <text x="380" y="107" textAnchor="middle" fontSize="13" fontWeight="600" fill="#6d28d9" fontFamily="Helvetica Neue,Arial,sans-serif">Review</text>
              </g>
              <g>
                <rect x="445" y="84" width="105" height="36" rx="18" fill="#f0fdf4" stroke="#86efac" strokeWidth="1.2" />
                <text x="497" y="107" textAnchor="middle" fontSize="13" fontWeight="600" fill="#16a34a" fontFamily="Helvetica Neue,Arial,sans-serif">Resolved</text>
              </g>

              <path d="M 145 102 L 170 102" stroke="#8492a6" strokeWidth="1.4" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" />
              <path d="M 300 102 L 325 102" stroke="#8492a6" strokeWidth="1.4" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" />
              <path d="M 435 102 L 440 102" stroke="#8492a6" strokeWidth="1.4" fill="none" markerEnd="url(#arr)" markerStart="url(#arr)" />

              <g>
                <rect x="180" y="148" width="240" height="24" rx="12" fill="#fff4f1" stroke="#fcd9c5" strokeWidth="1.2" />
                <text x="300" y="164" textAnchor="middle" fontSize="11" fontWeight="700" fill="#EC4119" fontFamily="Helvetica Neue,Arial,sans-serif" letterSpacing="0.5">
                  🔒 CLOSE PERMISSION REQUIRED
                </text>
              </g>

              <path d="M 90 120 C 90 160, 200 175, 270 196" stroke="#EC4119" strokeWidth="1.5" fill="none" markerEnd="url(#arrP)" />
              <path d="M 235 120 C 235 158, 270 178, 290 196" stroke="#EC4119" strokeWidth="1.5" fill="none" markerEnd="url(#arrP)" />
              <path d="M 380 120 C 380 158, 330 178, 310 196" stroke="#EC4119" strokeWidth="1.5" fill="none" markerEnd="url(#arrP)" />
              <path d="M 497 120 C 497 160, 400 175, 330 196" stroke="#EC4119" strokeWidth="1.5" fill="none" markerEnd="url(#arrP)" />

              <g>
                <rect x="240" y="198" width="120" height="38" rx="19" fill="#1e2a3a" stroke="#1e2a3a" />
                <text x="300" y="222" textAnchor="middle" fontSize="14" fontWeight="700" fill="#fff" fontFamily="Helvetica Neue,Arial,sans-serif">
                  🔒 Closed
                </text>
              </g>
            </svg>
          </div>

          <div className="og-flow-legend">
            <span className="og-lg"><span className="og-lg-line"></span> Free transition (any user)</span>
            <span className="og-lg"><span className="og-lg-line-primary"></span> Requires Close permission</span>
          </div>
        </div>

        {/* KEY RULES */}
        <div className="og-rules">
          <div className="og-rules-title"><i className="fa-solid fa-circle-check"></i>Key rules at a glance</div>
          <div className="og-rules-grid">
            <div className="og-rule"><b>•</b>Client required before project</div>
            <div className="og-rule"><b>•</b>Client &amp; Project need create/edit permission</div>
            <div className="og-rule"><b>•</b>Private = named members only</div>
            <div className="og-rule"><b>•</b>Modules &amp; segments before tasks</div>
            <div className="og-rule"><b>•</b>Project status ≠ task status</div>
            <div className="og-rule"><b>•</b>All members edit all tasks</div>
            <div className="og-rule"><b>•</b>Task can move any state ⇄ any state</div>
            <div className="og-rule"><b>•</b>Closing a task needs permission</div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}